import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { PageTitle, Card, Field, inputCls, SaveButton } from "@/components/admin/ui";

export default function AdminSettings() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const change = async () => {
    if (nw.length < 6) return toast.error("New password must be at least 6 characters.");
    if (nw !== confirm) return toast.error("New passwords do not match.");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password updated successfully");
      setCur(""); setNw(""); setConfirm("");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail, "Failed to update password"));
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings">
      <PageTitle title="Site Settings" subtitle="Account and security" />
      <Card title="Change Password" className="max-w-xl">
        <Field label="Current Password"><input type="password" className={inputCls} value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password-input" /></Field>
        <Field label="New Password"><input type="password" className={inputCls} value={nw} onChange={(e) => setNw(e.target.value)} data-testid="new-password-input" /></Field>
        <Field label="Confirm New Password"><input type="password" className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-password-input" /></Field>
        <SaveButton onClick={change} saving={saving} label="Update Password" testid="save-password" />
      </Card>
    </div>
  );
}
